module.exports = __webpack_public_path__ + "img/tu2.5532df95.png";